import React, { useState } from 'react';
import { Gift, Copy, Share2, Check } from 'lucide-react';

const ReferralSection = ({ referralCode, referralCount, referralEarnings }) => {
  const [copied, setCopied] = useState(false);

  const code = referralCode || 'OTG-XXXX';

  const handleCopy = () => {
    navigator.clipboard?.writeText(code)?.then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleShare = () => {
    if (navigator?.share) {
      navigator.share({
        title: 'Join OnTheGo!',
        text: `Use my referral code ${code} to get a discount on your first ride with OnTheGo!`,
        url: 'https://onthegosu7853.builtwithrocket.new',
      });
    } else {
      handleCopy();
    }
  };

  return (
    <div className="bg-gradient-to-br from-[#1a365d] to-[#2d5a87] rounded-2xl p-5 text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-[#ffd700]/10 rounded-full -translate-y-1/2 translate-x-1/2" />
      <div className="relative">
        <div className="flex items-center gap-2 mb-4">
          <Gift className="w-5 h-5 text-[#ffd700]" />
          <h3 className="font-semibold">Referral Program</h3>
        </div>
        <p className="text-white/70 text-sm mb-4">Share your code and earn KSh 100 for every friend who completes their first ride.</p>
        <div className="bg-white/10 rounded-xl p-3 flex items-center justify-between mb-4">
          <span className="font-mono text-lg font-bold tracking-widest text-[#ffd700]">{code}</span>
          <div className="flex gap-2">
            <button
              onClick={handleCopy}
              className={`p-2 rounded-lg transition-colors ${copied ? 'bg-green-500/30 text-green-300' : 'bg-white/10 hover:bg-white/20 text-white'}`}
            >
              {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
            </button>
            <button
              onClick={handleShare}
              className="p-2 bg-[#ffd700] rounded-lg hover:bg-[#fbbf24] transition-colors"
            >
              <Share2 className="w-4 h-4 text-[#1a365d]" />
            </button>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-white/10 rounded-xl p-3 text-center">
            <p className="text-2xl font-bold text-[#ffd700]">{referralCount ?? 0}</p>
            <p className="text-xs text-white/60 mt-0.5">Friends Referred</p>
          </div>
          <div className="bg-white/10 rounded-xl p-3 text-center">
            <p className="text-2xl font-bold text-[#ffd700]">KSh {(referralEarnings ?? 0)?.toLocaleString()}</p>
            <p className="text-xs text-white/60 mt-0.5">Rewards Earned</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralSection;
